// public/js/components/payment-manager.js

export default function PaymentManager(rootEl) {
  const payBtn = rootEl.querySelector('[data-action="pay"]');
  const stripeUI = rootEl.querySelector('[data-ref="stripe-ui"]');
  const successMsg = rootEl.querySelector('[data-ref="success-msg"]');
  const nextBtn = rootEl.querySelector('[data-action="next"]');

  if (!payBtn || !stripeUI || !successMsg) {
    throw new Error('PaymentManager: Missing required DOM elements (pay button, stripe ui, or success message)');
  }

  // Spinner SVG for the button state
  const SPINNER_SVG = `
    <svg class="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
    </svg>
    Processing...
  `;

  const handlePayment = async () => {
    // 1. Lock UI
    const originalBtnText = payBtn.innerHTML;
    payBtn.disabled = true;
    payBtn.innerHTML = SPINNER_SVG;
    stripeUI.classList.add('opacity-50', 'pointer-events-none');

    try {
      // 2. Simulate Network Request (Stripe Confirm)
      // In production, await stripe.confirmPayment(...) here
      await new Promise(resolve => setTimeout(resolve, 2000));

      // 3. UI Success Transition
      stripeUI.style.display = 'none';
      successMsg.classList.remove('hidden');

      if (window.lucide?.createIcons) {
        window.lucide.createIcons({ root: successMsg });
      }

      // 4. Reveal "Continue" or Auto-Submit
      // In an MPA, we usually want to POST to the server now to record the transaction
      if (nextBtn) {
        // If there's a specific 'Next' button in the footer, unlock it
        payBtn.classList.add('hidden');
        nextBtn.click(); // Or let user click it
      } else {
        // Otherwise, submit the form automatically after a brief pause
        setTimeout(() => {
          rootEl.submit();
        }, 1000);
      }

    } catch (error) {
      // Handle Errors (Reset UI)
      console.error(error);
      payBtn.disabled = false;
      payBtn.innerHTML = originalBtnText;
      stripeUI.classList.remove('opacity-50', 'pointer-events-none');
    }
  };

  payBtn.addEventListener('click', (e) => {
    e.preventDefault();
    handlePayment();
  });
}